export const CHANNEL_SETTING_TYPE_MAP = {
  GROUP: "group",
  CHANNEL: "channel",
};
